// extracted by mini-css-extract-plugin
export default {"container":"lR3yj5","placeholder":"dDcMfv"};